export const DEFAULT_LOCALE = 'no' as const

// All locales supported by the app (it is fine that it includes 'no')
export const SUPPORTED_LOCALES = ['en', 'no'] as const
export type Locale = typeof SUPPORTED_LOCALES[number]

export const PREFIX_LOCALES = SUPPORTED_LOCALES.filter(
  (locale): locale is Exclude<Locale, typeof DEFAULT_LOCALE> => locale !== DEFAULT_LOCALE
)

export function isLocale(value: string): value is Locale {
  return SUPPORTED_LOCALES.some((locale) => locale === value)
}
